import { useEffect } from 'react';
import { track } from './track';

export const useAnalytics = (env: string) => {
  const _trackPage = () => {
    track('Page Viewed', { path: window.location.pathname });
  };

  const _trackButtonClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const button = target.closest('button');

    if (button && button.dataset.track) {
      track('Button Clicked', {
        text: button.innerText.trim(),
        id: button.id || null,
        class: button.className || null,
      });
    }
  };

  useEffect(() => {
    // Initialize Mixpanel
    // document.addEventListener('click', _trackButtonClick);
    window.addEventListener('popstate', _trackPage);
    window.addEventListener('pushstate', _trackPage);
    window.addEventListener('replacestate', _trackPage);
    _trackPage(); // Track initial page load

    return () => {
      // document.removeEventListener('click', _trackButtonClick);
      window.removeEventListener('popstate', _trackPage);
      window.removeEventListener('pushstate', _trackPage);
      window.removeEventListener('replacestate', _trackPage);
    };
  }, []);
};
